import React from 'react';
import { Link } from 'gatsby';

const Subnav = ({ sublinks }) => {

	const getKey = route => {
		return route.replaceAll("/", "_")
	}

	return (
		<ul className="submenu">
			{sublinks.map((sublink) => (
				<li className="submenu__item" key={getKey(sublink.route)}>
					{sublink.title === 'Overview' ? 
						(
							<Link
								to={sublink.route}
								className="submenu__link"
								activeClassName="submenu__link--active">
								{sublink.title}
							</Link>
						) 
						: 
						(
							<Link
								to={sublink.route}
								className="submenu__link"
								getProps={({ isPartiallyCurrent }) =>
									isPartiallyCurrent ? { className: "submenu__link submenu__link--active" } : null
									}>
								{sublink.title}
							</Link>
						) 
					}
				</li>
			))}
		</ul>
	);
};

export default Subnav;
